import { useNavigate } from "react-router-dom";
import { AdminTemplate, AnnulmentQueriesListTable } from "../../components";

export const AnnulmentQueriesList = () => {
    const navigate = useNavigate();

    const handleAddButton = () => navigate("/merchant-management/merchant-identification");

    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Fesih Takip Sistemi",
                hideAddButton: true,
                //onClickAddButton: handleAddButton,
            }}
        >
            <AnnulmentQueriesListTable />
        </AdminTemplate>
    );
};

